
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { UserModel } from '@/models/user.model';
import { teamsState } from '@/utils/store-acessor';

@Component({})
export default class UserCard extends Vue {
  @Prop({ required: true }) user!: UserModel;
  @Prop({ required: false }) height!: number;
  @Prop({ required: false, default: false }) isTeamLeader!: boolean;
  @Prop({ required: false, default: false }) showClickColor!: boolean;
  private isClicked = false;

  onUserSelected() {
    this.isClicked = !this.isClicked;
    if (this.user?.id) {
      teamsState.onUpsertUserInvitation(this.user.id);
    }
  }

  get showClickedColor(): boolean {
    return this.showClickColor && this.isClicked;
  }

  openPublicProfile() {
    if (this.user?.slug) {
      const blankPage = this.$router.resolve({
        name: 'ProfileAbout',
        params: {
          slug: this.user.slug,
        }
      });
      window.open(blankPage.href, '_blank');
    }
  }
}
